<template>
  <div id="multiSensorHiL" :class="{ 'box': true, 'landscape-box': isLandscape, 'portrait-box': !isLandscape }">
    <!-- <div id="multiSensorHiL"> -->
    <div id="multiSensorHiLModule1" :style="{ 'background-image': 'url(' + imageUrl1 + ')' }" v-lazy="imageUrl1">
      <div id="multiSensorHiLModule1Text" class="gaiAModule1">
        <div id="multiSensorHiLModule1TextText1" class="module1">{{ $t('productCenterHiLView').multiSensorHiLModule1.h1 }}
        </div>
        <div id="multiSensorHiLModule1TextText2" class="module1">{{ $t('productCenterHiLView').multiSensorHiLModule1.h2 }}
        </div>
      </div>
    </div>
    <div id="coteent">
      <div id="multiSensorHiLModule2">
        <div id="multiSensorHiLModule2Content">
          <div id="multiSensorHiLModule2Title" class="wow animate__animated animate__fadeInUp">
            {{ $t('productCenterHiLView').multiSensorHiLModule2.h1 }}
          </div>
          <div id="multiSensorHiLModule2Process" class="wow animate__animated animate__fadeInUp">
            <div id="multiSensorHiLModule2ProcessLeft">
              <div id="multiSensorHiLModule2ProcessLeftBox1">
                <div id="multiSensorHiLModule2ProcessLeftBoxLeft"
                  :style="{ 'background-image': 'url(' + imageUrl2 + ')' }" v-lazy="imageUrl2">
                  {{
                    $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessLeft.multiSensorHiLModule2Arr[0]
                  }}
                </div>
                <div id="multiSensorHiLModule2ProcessLeftBoxRight"
                  :style="{ 'background-image': 'url(' + imageUrl3 + ')' }" v-lazy="imageUrl3">
                  {{
                    $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessLeft.multiSensorHiLModule2Arr[1]
                  }}
                </div>
              </div>
              <div id="multiSensorHiLModule2ProcessLeftBox2">
                <div id="multiSensorHiLModule2ProcessLeftBoxLeft"
                  :style="{ 'background-image': 'url(' + imageUrl2 + ')' }" v-lazy="imageUrl2">
                  {{
                    $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessLeft.multiSensorHiLModule2Arr[2]
                  }}
                </div>
                <div id="multiSensorHiLModule2ProcessLeftBoxRight"
                  :style="{ 'background-image': 'url(' + imageUrl3 + ')' }" v-lazy="imageUrl3">
                  {{
                    $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessLeft.multiSensorHiLModule2Arr[3]
                  }}
                </div>
              </div>
              <div id="multiSensorHiLModule2ProcessLeftBox3">
                <div id="multiSensorHiLModule2ProcessLeftBoxLeft"
                  :style="{ 'background-image': 'url(' + imageUrl2 + ')' }" v-lazy="imageUrl2">
                  {{
                    $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessLeft.multiSensorHiLModule2Arr[4]
                  }}
                </div>
                <div id="multiSensorHiLModule2ProcessLeftBoxRight"
                  :style="{ 'background-image': 'url(' + imageUrl3 + ')' }" v-lazy="imageUrl3">
                  {{
                    $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessLeft.multiSensorHiLModule2Arr[5]
                  }}
                </div>
              </div>
            </div>
            <div id="multiSensorHiLModule2ProcessRight">
              <div id="multiSensorHiLModule2ProcessRightRow" :style="{ 'background-image': 'url(' + imageUrl6 + ')' }"
                v-lazy="imageUrl6">
                <div id="multiSensorHiLModule2ProcessRightRowSense1"
                  :style="{ 'background-image': 'url(' + imageUrl5 + ')' }" v-lazy="imageUrl5">
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg"><img src="@/static/img/HiLSense.png" alt="">
                    </div>
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[0]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[1]
                    }}
                  </div>
                </div>
                <div id="multiSensorHiLModule2ProcessRightRowSense2"
                  :style="{ 'background-image': 'url(' + imageUrl5 + ')' }" v-lazy="imageUrl5">
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg"><img src="@/static/img/HiLperception.png"
                        alt=""></div>
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[2]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[3]
                    }}

                  </div>
                </div>
                <div id="multiSensorHiLModule2ProcessRightRowSense3"
                  :style="{ 'background-image': 'url(' + imageUrl5 + ')' }" v-lazy="imageUrl5">
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg"><img src="@/static/img/HiLmerge.png" alt="">
                    </div>
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[4]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[5]
                    }}
                  </div>
                </div>
                <div id="multiSensorHiLModule2ProcessRightRowSense4"
                  :style="{ 'background-image': 'url(' + imageUrl5 + ')' }" v-lazy="imageUrl5">
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg"><img src="@/static/img/HiLApplication.png"
                        alt=""></div>
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[6]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t('productCenterHiLView').multiSensorHiLModule2.multiSensorHiLModule2ProcessRight.multiSensorHiLModule2Arr[7]
                    }}
                  </div>
                </div>
              </div>
              <div id="multiSensorHiLModule2ProcessRightCol" :style="{ 'background-image': 'url(' + imageUrl4 + ')' }"
                v-lazy="imageUrl4">
                <span v-if="showTestObject"
                  class="vertical-text">A<br>D<br>A<br>S<br>/<br>A<br>D<br />被<br />测<br />对<br />象</span>
                <span v-else class="vertical-text">A<br>D<br>A<br>S<br>/<br>A<br>D<br>O<br>b<br>j<br>e<br>c<br>t</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="multiSensorHiLModule3" :style="{ 'background-image': 'url(' + imageUrl7 + ')' }" v-lazy="imageUrl7">
        <div id="multiSensorHiLModule3Box">
          <div id="multiSensorHiLModule3Title" class="wow animate__animated animate__fadeInUp">
            {{ $t('productCenterHiLView').multiSensorHiLModule3 }}
          </div>
          <div id="multiSensorHiLModule3Video" class="wow animate__animated animate__fadeInUp">
            <img src="@/static/img/HiLProductBanner.png" alt="">
          </div>
        </div>
      </div>
      <div id="multiSensorHiLFooter">
        <FooterComponents></FooterComponents>
      </div>
    </div>
  </div>
</template>
  
<script>
import FooterComponents from '@/components/FooterComponents.vue';
import WOW from 'wowjs';

export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90
    }
  },
  components: {
    FooterComponents,
  },
  updated() {
    let lang = localStorage.getItem('lang')
    if (lang == 'en-US') {
      this.showTestObject = false
    } else {
      this.showTestObject = true
    }
  },
  data() {
    return {
      imageUrl1: require("@/static/img/HiLbanner.png"),
      imageUrl2: require("@/static/img/HiLBox.png"),
      imageUrl3: require("@/static/img/HiLArrow.png"),
      imageUrl4: require("@/static/img/HilColorCol.png"),
      imageUrl5: require("@/static/img/HilColorBox.png"),
      imageUrl6: require("@/static/img/HiLRowBg.png"),
      imageUrl7: require("@/static/img/HiLProductBg.png"),
      showTestObject: true,
      futureList: [
        {
          icon: require('@/static/img/futureIcon1.svg'),
          h1: '高保真传感器',
          h2: '高精度的激光雷达、毫米波雷达、摄像头等物理传感器和理想传感器仿真',
        },
        {
          icon: require('@/static/img/futureIcon2.svg'),
          h1: '智慧交通流',
          h2: 'AI驱动的智慧随机交通流',
        },
        {
          icon: require('@/static/img/futureIcon3.svg'),
          h1: '高精度车辆动力学',
          h2: '支持导入第三方车辆动力学模型（FMI接口），支持对模型参数进行实时修改',
        },
        {
          icon: require('@/static/img/futureIcon4.svg'),
          h1: '支持 ASAM OpenX标准',
          h2: '支持OpenDRIVE和OpenSCENARIO格式文件导入导出',
        },
        {
          icon: require('@/static/img/futureIcon5.svg'),
          h1: '高拓展性',
          h2: '硬件系统基于模块化设计，具有较好的扩展性',
        },
        {
          icon: require('@/static/img/futureIcon6.svg'),
          h1: '高效的管理大屏',
          h2: '实现数据实时采集、记录、监控、配置，提高使用便捷性与效率',
        },
        {
          icon: require('@/static/img/futureIcon7.svg'),
          h1: '丰富的接口形式',
          h2: '支持CAN、LIN、车载以太网、以太网通讯以及通用I/O接口仿真，支持LVDS功能扩展',
        },
        {
          icon: require('@/static/img/futureIcon8.svg'),
          h1: '灵活的自动化测试',
          h2: '支持在自动化测试序列中嵌入Python脚本语言，以实现复杂的测试步骤',
        },
        {
          icon: require('@/static/img/futureIcon9.svg'),
          h1: '直观的接口映射匹配',
          h2: '在树状拓扑结构中可将系统中的变量与硬件接口进行映射匹配',
        },
      ]
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90
      if (isLandscape) { location.reload() }
      else { location.reload(); }
    }
    window.addEventListener('orientationchange', reloadOnOrientationChange)
  },
  mounted() {
    let lang = localStorage.getItem('lang')
    if (lang == 'en-US') {
      this.showTestObject = false
    } else {
      this.showTestObject = true
    }
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  },
  methods: {

  },
};
</script>
  
<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
    flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#multiSensorHiL {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle($fontweight, $height, $fontSize, $lineHeight, $letterSpaceing, $color) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #multiSensorHiLModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 0rem 11rem 12.8125rem;



    #multiSensorHiLModule1Text {
      width: fit-content;
      height: 7.75rem;
      line-height: 3.875rem;

      #multiSensorHiLModule1TextText1 {
        @include fontStyle(600, 3.875rem, 2.5rem, 3.875rem, 0.06944rem, rgba(255, 255, 255, 0.85));
      }

      #multiSensorHiLModule1TextText2 {
        opacity: 1;
        margin-top: .75rem;
        @include fontStyle(400, 2rem, 1.0625rem, 2rem, 0.06944rem, rgba(255, 255, 255, 0.65));
      }
    }
  }

  #coteent {
    flex: 1;
    display: flex;
    flex-direction: column;

    #multiSensorHiLModule2 {
      width: 100%;
      flex: 0.5;
      padding: 4.875rem 0 0 0;
      @include display;

      #multiSensorHiLModule2Content {
        width: 100%;

        #multiSensorHiLModule2Title {
          margin: auto;
          @include fontStyle(600, 3.125rem, 2.25rem, 3.125rem, 0.06944rem, rgba(255, 255, 255, 0.85));
        }

        #multiSensorHiLModule2Process {
          margin: auto;
          display: flex;
          width: 64.5rem;
          height: 18.75rem;
          margin-top: 3.625rem;

          #multiSensorHiLModule2ProcessLeft {

            display: flex;
            height: 18.75rem;
            box-sizing: border-box;
            flex-direction: column;
            justify-content: space-evenly;

            #multiSensorHiLModule2ProcessLeftBox1,
            #multiSensorHiLModule2ProcessLeftBox2,
            #multiSensorHiLModule2ProcessLeftBox3 {
              display: flex;
              height: 3.9375rem;
              align-items: center;

              #multiSensorHiLModule2ProcessLeftBoxLeft {
                display: flex;
                align-items: center;
                justify-content: center;
                @include bgar(260/56);
                color: rgba(255, 255, 255, 0.85);
                width: fit-content;
                font-weight: 400;
                height: 3.5rem;
                font-size: 1rem;
                font-style: normal;
                color: rgba(255, 255, 255, 0.85);

              }

              #multiSensorHiLModule2ProcessLeftBoxRight {
                display: flex;
                align-items: center;
                justify-content: center;
                @include bgar(393/116);
                color: rgba(255, 255, 255, 0.85);
                width: fit-content;
                font-weight: 400;
                height: 3.5rem;
                font-size: 1rem;
                font-style: normal;
                color: rgba(255, 255, 255, 0.85);
              }
            }
          }

          #multiSensorHiLModule2ProcessRight {
            flex: 1;
            display: flex;
            flex-direction: row;
            border-radius: .25rem;

            #multiSensorHiLModule2ProcessRightRow {
              flex: 1;
              display: flex;
              border-radius: .25rem;
              padding: 0 2.75rem;
              background-size: cover;
              background-repeat: no-repeat;
              flex-direction: column;
              border: 1px solid #282D45;
              justify-content: space-evenly;
              border-right: 0px solid #282D45;

              #multiSensorHiLModule2ProcessRightRowSense1,
              #multiSensorHiLModule2ProcessRightRowSense2,
              #multiSensorHiLModule2ProcessRightRowSense3,
              #multiSensorHiLModule2ProcessRightRowSense4 {
                display: flex;
                width: 30rem;
                align-items: center;
                aspect-ratio: 371/44;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                justify-content: space-between;

                #multiSensorHiLModule2ProcessRightRowSenseBox {
                  display: flex;
                  align-items: center;
                  height: 2.75rem;
                  font-size: 1rem;
                  font-weight: 400;
                  @include display;
                  font-style: normal;
                  color: rgba(255, 255, 255, 0.85);
                  padding-left: .9375rem;

                  #multiSensorHiLModule2ProcessRightRowSenseBoxImg {
                    width: 1rem;
                    height: 1rem;
                    margin: .5rem .6rem .5rem;

                    img {
                      width: 1rem;
                      height: 1rem;
                      object-fit: cover;

                    }
                  }
                }

                #multiSensorHiLModule2ProcessRightRowSenseContent {
                  // flex: 1;
                  // display: flex;
                  // align-items: center;
                  width: 20rem !important;
                  margin-right: 1.5rem;
                  color: rgba(255, 255, 255, 0.85);
                  width: fit-content;
                  font-weight: 400;
                  font-size: 1rem;
                  font-style: normal;
                  box-sizing: border-box;
                  // padding-left: 3rem;
                  text-align: center;


                }
              }
            }

            #multiSensorHiLModule2ProcessRightCol {
              width: 4rem;
              font-size: 1rem;
              @include display;
              font-weight: 500;
              height: 18.75rem;
              text-align: center;
              aspect-ratio: 128/600;
              background-size: contain;
              background-repeat: no-repeat;
              color: rgba(255, 255, 255, 0.85);
              white-space: normal;

              .vertical-text {
                text-orientation: upright;
                white-space: normal;
              }
            }
          }
        }
      }

    }

    #multiSensorHiLModule3 {
      flex: 0.5;
      width: 100%;
      @include display;
      background-size: cover;
      padding: 4.1875rem 0 2.4375rem 0;
      /* @include whar(100%, 35.25rem, 1440/564); */
      /* @include whar(100%, auto, 1440/564); */
      /* background-color: red; */

      #multiSensorHiLModule3Box {
        width: 58.375rem;
        /* height: 27.9375rem; */
        box-sizing: border-box;
        /* background-color: blue; */
        margin: auto;

        #multiSensorHiLModule3Title {
          margin: auto;
        }

        #multiSensorHiLModule3Title {
          @include fontStyle(600, 3.125rem, 2.25rem, 3.125rem, 0.06944rem, rgba(255, 255, 255, 0.85));
          /* background-color: green; */
        }

        #multiSensorHiLModule3Video {
          width: 58.375rem;
          height: 21.4375rem;
          /* background-color: red; */

          img {
            width: 58.375rem;
            height: 21.4375rem;
            object-fit: cover;
          }
        }
      }
    }

    #multiSensorHiLFooter {
      width: 100%;
      height: 18rem;
    }
  }
}
</style>
  